import { render, staticRenderFns } from "./accountMenu.vue?vue&type=template&id=639e6b3a&"
import script from "./accountMenu.vue?vue&type=script&lang=ts&"
export * from "./accountMenu.vue?vue&type=script&lang=ts&"
import style0 from "./accountMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports